module.exports = __webpack_public_path__ + "static/media/location-fill.283e02d1.svg";